import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MournerItem from './MournerItem';
import './RecipientsMourners.scss';
const RecipientsMourners = ({ values, setFieldValue }) => {

  const { selectedDeceased } = useSelector((state) => state.CommonStates);
  let selectedMourners = [];
  const mourners = selectedDeceased?.map((dec) => {
    return dec?.mourners_list?.forEach((item) => {
      selectedMourners.push({
        ...item,
        name: dec?.name,
        'hebrew name of Death': dec?.hebrew_name_of_Death,
        'hebrew date of death': dec?.hebrew_date_of_death,
        'mother name': dec?.mother_name,
        'date of death': dec?.date_of_death,
        gender: dec?.gender,
        'about the deceased': dec?.about_the_deceased,
        cemetery: dec?.cemetery,
        'plaque number': dec?.plaque_number,
        deceasedId: dec?._id,
      });
      return item;
    });
  });

  const mournerWithEmail = selectedMourners?.filter(
    (item) => item?.member_id?.email_address || item?.email
    );

  useEffect(() => {
    if (!values?.recipients) {
      setFieldValue('recipients', mournerWithEmail);
      setFieldValue('mournerWithEmail', mournerWithEmail);
    }
  }, []);
  const selectMournerHandler = () => {
    if (values?.recipients?.length === mournerWithEmail?.length) {
      setFieldValue('recipients', []);
      setFieldValue('mournerWithEmail', []);
    } else {
      setFieldValue('recipients', mournerWithEmail);
      setFieldValue('mournerWithEmail', mournerWithEmail);
    }
  };


  useEffect(() => {
    const unselectedMournersWithEmail = mournerWithEmail?.filter(
      (item) => !values?.recipients?.find((rec) => rec?._id === item?._id)
    );
    if (unselectedMournersWithEmail && !!unselectedMournersWithEmail.length) {
      setFieldValue('unselectedMournersWithEmail', unselectedMournersWithEmail);
    } else {
      setFieldValue('unselectedMournersWithEmail', []);
    }
  }, [values?.recipients]);

  return (
    <div className="recipients">
      <div className="recipients__title">
        <h3> Recipients </h3>
        <h3>{values?.mournerWithEmail?.length}</h3>
      </div>
      <div className="listText">
        The following is a list of the {values?.mournerWithEmail?.length} recipients.
      </div>
      <hr />
      <div className="mourner-select-all">
        <button className="btn"
          onClick={selectMournerHandler}
        >{values?.recipients?.length === mournerWithEmail?.length ? 'Deselect All' : 'Select All'} </button>
      </div>
      <div className="mourner_list">
        {mournerWithEmail?.map((item) => (
          <MournerItem
            key={item?._id}
            id={item?._id}
            item={item}
            profile_img={item?.member_id?.profile_img}
            email={item?.member_id?.email_address || item?.email}
            full_name={item?.member_id?.full_name}
            first_name={item?.member_id?.first_name}
            last_name={item?.member_id?.last_name}
            // selectedRicipient={selectedRicipient}
            // setSelectedRicipient={setSelectedRicipient}
            values={values}
            setFieldValue={setFieldValue}
            selectedMourners={selectedMourners}
          />
        ))}
      </div>
    </div>
  );
};

export default RecipientsMourners;
